import * as t from "./actionTypes";

export function toggleShowPrice() {
  return {
    type: t.TOGGLE_SHOW_PRICE
  };
}

export function toggleShowUVP() {
  return {
    type: t.TOGGLE_SHOW_UVP
  };
}

export function setCurrentUser(user) {
  return {
    type: t.SET_CURRENT_USER,
    payload: user
  };
}

export function contact(textMessage, clientID) {
  return function contactThunk(dispatch, getState, { api }) {
    dispatch({ type: t.CONTACT_REQUEST });
    dispatch({ type: t.CONTACT_DRAFT, payload: textMessage });
    return api
      .contact({
        textMessage,
        clientID
      })
      .then(resp => {
        dispatch({ type: t.CONTACT_REQUEST_SUCCESS, payload: resp.data.msg });
      })
      .catch(err => {
        dispatch({ type: t.CHECKOUT_REQUEST_FAILURE, payload: err });
      });
  };
}

export function checkout({ client, cart }) {
  return function checkoutThunk(dispatch, getState, { api }) {
    dispatch({ type: t.CHECKOUT_REQUEST });
    return api
      .checkout({
        client,
        cart
      })
      .then(resp => {
        dispatch({ type: t.CHECKOUT_REQUEST_SUCCESS, payload: resp.data.msg });
        dispatch({ type: t.FLUSH_CART });
      })
      .catch(err => {
        dispatch({ type: t.CHECKOUT_REQUEST_FAILURE, payload: err });
      });
  };
}

export function login({ clientID, password }) {
  return function loginThunk(dispatch, getState, { api }) {
    dispatch({ type: t.LOGIN_REQUEST });
    return api
      .login({
        clientID,
        password
      })
      .then(resp => {
        dispatch({ type: t.LOGIN_REQUEST_SUCCESS, payload: resp.data.token });
        dispatch({ type: t.SET_CURRENT_USER, payload: resp.data.client });
      })
      .catch(err => {
        dispatch({ type: t.LOGIN_REQUEST_FAILURE, payload: err });
      });
  };
}

export function logout() {
  return {
    type: t.LOGOUT_USER
  };
}

export function deleteCartItem(article) {
  return {
    type: t.DELETE_CART_ITEM,
    payload: article
  };
}

export function addCartItem(article) {
  return {
    type: t.ADD_CART_ITEM,
    payload: article
  };
}



// WEBPACK FOOTER //
// ./src/redux/actionCreators.js